import { render, staticRenderFns } from "./icon-wrap.vue?vue&type=template&id=c23bc92e&"
import script from "./icon-wrap.vue?vue&type=script&lang=ts&"
export * from "./icon-wrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports